import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputFileConfig, InputFileModule as InputFile } from 'ngx-input-file';

const config: InputFileConfig = {
  fileLimit: 1,
  iconAdd: 'save_alt'
};

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    InputFile.forRoot(config),
  ],
  exports: [
    InputFile
  ]
})
export class InputFileModule { }
